import { useReactiveVar } from '@apollo/client';
import { useNavigation } from '@react-navigation/native';
import FeatureFlagsContext from 'context/FeatureFlagsContext';
import { useCallback, useContext } from 'react';
import { featureCountryCode } from 'states/persistInStorage';
import { CountryCode } from 'types/generatedSchemaTypes';
import { AccountScreenNavigationProp } from 'types/navigation';
import { presentIntercom } from 'utils/chatbot';
import { canOpenChatbot } from 'utils/commonUtils';
import { isWeb } from 'utils/deviceUtils';
import { isIntercomEnabledForCountry } from 'utils/featureFlagUtils';

interface SupportStatus {
  isAvailable: boolean;
  open: () => Promise<void>;
}

const useSupportStatus = (): SupportStatus => {
  const {
    flags: { chatbot_urls, intercom_enabled },
  } = useContext(FeatureFlagsContext);
  const currentCountry = useReactiveVar(featureCountryCode);
  const { navigate: navigateAccount } =
    useNavigation<AccountScreenNavigationProp>();

  const isIntercomEnabled =
    !isWeb &&
    isIntercomEnabledForCountry(
      intercom_enabled,
      currentCountry as CountryCode
    );
  const isWebChatEnabled = canOpenChatbot(chatbot_urls, currentCountry);

  const isAvailable = isWebChatEnabled || isIntercomEnabled;

  const open = useCallback(async () => {
    if (isIntercomEnabled) {
      await presentIntercom();
    } else {
      navigateAccount('chatbot');
    }
  }, [isIntercomEnabled, navigateAccount]);

  return { isAvailable, open };
};

export default useSupportStatus;
